<template>
  <v-row no-gutters class="d-flex align-center px-3 pt-8 pb-4 line-inputs">
    <v-col cols="5">
      <v-text-field
        dense
        hide-details
        v-model="attributeModel"
        class="mr-2 input-attr"
        color="grey darken-3"
        :disabled="!editableKey"
        label="Atribute"
      />
    </v-col>

    <v-col cols="5" v-if="!this.isSwitch && !showHeadersType">
      <v-text-field
        dense
        hide-details
        v-model="valueModel"
        label="Value"
        append-icon="info"
        color="grey darken-3"
        @click:append="handleOpenMenuValueType($event)"
        :disabled="isObject"
      />

      <v-menu transition="slide-y-transition" v-model="showMenu" bottom :position-x="x" :position-y="y">
        <v-card class="px-3 py-1" flat tile>
          <v-radio-group v-model="radioGroupType" @change="handleSetValueType" :mandatory="false" color="grey darken-3">
            <v-radio label="String" value="string" />
            <v-radio label="Number" value="number" />
            <v-radio label="Boolean" value="boolean" />
            <v-radio label="Object" value="object" />
          </v-radio-group>
        </v-card>
      </v-menu>
    </v-col>

    <v-col cols="5" v-if="this.isSwitch && !showHeadersType">
      <v-switch v-model="valueModel" label="Value" dense class="mt-0" color="grey darken-3" hide-details />
    </v-col>

    <v-col cols="5" v-if="showHeadersType">
      <v-select
        :items="listTypes"
        v-model="valueModel"
        label="Value"
        class
        hide-details
        dense
        append-icon="zmdi zmdi-chevron-down"
        color="grey darken-3"
      />
    </v-col>

    <v-col cols="2" class="text-center">
      <v-icon small @click="addLine()">{{ typeLine ? 'fas fa-pencil-alt' : 'add' }}</v-icon>
    </v-col>

    <v-icon @click="handleCloseDivInputs()" class="line-inputs__close" small>close</v-icon>
  </v-row>
</template>

<script>
export default {
  data: () => ({
    attributeModel: '',
    valueModel: '',
    radioGroupType: '',
    showMenu: false,
    x: null,
    y: null,
    isSwitch: false,
    isObject: false,
    listTypes: ['date', 'dateTime', 'decimal', 'zipcode', 'phone', 'cpf', 'cnpj', 'percentageSymbol'],
    showHeadersType: false
  }),

  props: {
    editableKey: { type: Boolean, default: true },
    typeLine: { type: Boolean, default: false, required: true },
    objItem: { type: Object, default: { key: '', value: '' }, required: true },
    headersType: { type: Boolean, default: false }
  },

  mounted() {
    if (this.typeLine) {
      this.attributeModel = this.objItem.key;
      this.valueModel = this.objItem.value;
      this.isSwitch = false;

      if (this.objItem.value.toString() == 'false' || this.objItem.value.toString() == 'true') {
        this.isSwitch = true;
        this.valueModel = this.objItem.value.toString() == 'false' ? false : true;
      }
    }
  },

  methods: {
    handleCloseDivInputs() {
      this.$emit('close');
    },

    addLine() {
      let actionType = this.typeLine ? 'edit' : 'add';

      if (this.valueModel == 'false' || this.valueModel == 'true') {
        this.valueModel = this.valueModel == 'false' ? false : true;
      }

      this.$emit('actionList', { type: actionType, key: this.attributeModel, value: this.valueModel });
    },

    handleOpenMenuValueType(e) {
      this.x = e.x - 110;
      this.y = e.y + 10;

      this.showMenu = true;
    },

    handleSetValueType() {
      this.isObject = false;

      if (this.radioGroupType === 'string') {
        this.valueModel = this.valueModel.toString();
      }

      if (this.radioGroupType === 'number') {
        this.valueModel = parseFloat(this.valueModel);
      }

      if (this.radioGroupType === 'boolean') {
        if (this.valueModel.toString() == 'false') {
          this.valueModel = false;
        }

        if (this.valueModel.toString() == 'true') {
          this.valueModel = true;
        }
      }

      if (this.radioGroupType === 'object') {
        let objectDefault = '{"": ""}';

        this.isObject = true;
        this.valueModel = JSON.parse(objectDefault);
      }
    }
  },

  watch: {
    attributeModel: {
      deep: true,
      handler: function(newValue, oldValue) {
        if (newValue) {
          if (this.headersType && newValue == 'type') {
            this.showHeadersType = true;
          } else {
            this.showHeadersType = false;
          }
        }
      }
    }
  }
};
</script>
